const getCurrencyCode = (symbol: string): string => {
  switch (symbol) {
    case '*CHF': {
      return 'CHF'
    }
    case 'CHF': {
      return 'CHF'
    }
    default: {
      return 'EUR'
    }
  }
}

export const priceAccessorGetParsedPrice = (
  price?: string,
): { amount: number; currency: string } | null => {
  if (!price) {
    return null
  }

  const regexp = /^(?<currency>.+)\s(?<amount>\d+[,.]\d+)/u
  const match = regexp.exec(String(price))

  if (!match?.groups?.currency || !match.groups.amount) {
    return null
  }
  const parsedPrice = match.groups.amount.replaceAll(',', '.')
  const amount = Number.parseFloat(parsedPrice)

  return {
    amount,
    currency: getCurrencyCode(match.groups.currency),
  }
}
